export const LEGAL_DOCS = {
  "politica-de-privacidade": {
    slug: "politica-de-privacidade",
    eyebrow: "Área legal · Política de Privacidade",
    title: "Política de Privacidade",
    intro:
      "Como os dados pessoais poderão ser coletados, utilizados, armazenados, compartilhados e protegidos no site e nos serviços do OFF360 e do 360Taxi.",
    version: "1.0",
    sections: [
      {
        h: "2.1",
        t: "Apresentação",
        paras: [
          "A OFF360 TECNOLOGIA SERVICOS E SOLUCOES LTDA, identificada neste documento como OFF360, respeita a privacidade e a proteção dos dados pessoais dos usuários de suas plataformas.",
          "Esta Política de Privacidade explica como os dados pessoais poderão ser coletados, utilizados, armazenados, compartilhados e protegidos durante o acesso ao site e aos serviços disponibilizados pelo OFF360 e pelo 360Taxi.",
          "O tratamento de dados observa a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018), o Marco Civil da Internet e demais normas aplicáveis.",
        ],
      },
      {
        h: "2.2",
        t: "Dados pessoais tratados",
        paras: ["Dependendo do serviço utilizado, poderão ser tratados:"],
        groups: [
          { t: "Dados de identificação", d: "nome, data de nascimento, telefone, e-mail e outras informações fornecidas no cadastro." },
          { t: "Dados de localização", d: "localização do dispositivo, origem, destino, percurso e informações necessárias à execução das corridas." },
          { t: "Dados dos motoristas", d: "informações da CNH, EAR, documentos cadastrais, dados do veículo, comprovantes exigidos, seguro e informações necessárias à validação e autorização da atividade." },
          { t: "Dados financeiros", d: "informações necessárias ao processamento de pagamentos, registros de transações, cobranças, saldos e recebimentos." },
          { t: "Dados operacionais", d: "histórico de corridas, solicitações, cancelamentos, avaliações e interações com o suporte." },
          { t: "Dados técnicos", d: "informações de dispositivo, sistema operacional, registros de acesso e dados necessários ao funcionamento e à segurança da plataforma." },
          { t: "Pré-cadastro", d: "nome completo, e-mail, modalidade de interesse e registros das autorizações concedidas." },
        ],
        paras2: [
          "A relação definitiva de dados será validada conforme a coleta efetivamente realizada nos aplicativos e serviços integrados.",
        ],
      },
      {
        h: "2.3",
        t: "Finalidades do tratamento",
        paras: ["Os dados poderão ser tratados para:"],
        list: [
          "Criar e administrar contas de usuários;",
          "Verificar identidade e documentação;",
          "Permitir a solicitação e execução de corridas;",
          "Identificar motoristas e passageiros;",
          "Calcular e apresentar informações das viagens;",
          "Viabilizar pagamentos e recebimentos;",
          "Prestar atendimento e suporte;",
          "Gerenciar solicitações, reclamações e incidentes;",
          "Prevenir fraudes e atividades irregulares;",
          "Cumprir obrigações legais e regulatórias;",
          "Proteger a segurança dos usuários;",
          "Enviar comunicações operacionais;",
          "Informar sobre lançamentos solicitados pelo interessado;",
          "Enviar comunicações promocionais quando houver autorização ou outra base legal adequada.",
        ],
      },
      {
        h: "2.4",
        t: "Bases legais",
        paras: [
          "Os dados serão tratados conforme as bases legais aplicáveis a cada finalidade, incluindo, quando cabível, execução contratual, cumprimento de obrigação legal ou regulatória, exercício regular de direitos, legítimo interesse e consentimento.",
          "O consentimento não será apresentado como a única base legal para todas as operações. As bases legais serão documentadas e relacionadas aos fluxos reais de tratamento.",
        ],
      },
      {
        h: "2.5",
        t: "Localização",
        paras: [
          "O aplicativo 360Taxi poderá utilizar a localização para identificar pontos de embarque e desembarque, localizar motoristas disponíveis, calcular rotas e acompanhar corridas.",
          "O uso da localização ocorrerá conforme as permissões concedidas e os recursos efetivamente utilizados. A coleta de localização em segundo plano, caso implementada, será descrita expressamente, indicando sua finalidade e as condições de utilização.",
        ],
      },
      {
        h: "2.6",
        t: "Compartilhamento de informações",
        paras: ["Os dados poderão ser compartilhados na medida necessária com:"],
        list: [
          "Motoristas e passageiros envolvidos em uma corrida;",
          "Provedores de infraestrutura tecnológica;",
          "Serviços de mapas e geolocalização;",
          "Prestadores de serviços financeiros;",
          "Serviços de validação documental;",
          "Fornecedores de comunicação e suporte;",
          "Autoridades públicas, quando houver obrigação legal.",
        ],
        paras2: [
          "Dados financeiros ou documentais de outros usuários não são divulgados publicamente.",
        ],
      },
      {
        h: "2.7",
        t: "Segurança dos dados",
        paras: [
          "O OFF360 adota medidas técnicas e administrativas adequadas à proteção de dados pessoais, considerando controles de acesso, proteção de credenciais, segurança de transmissão, prevenção de acessos indevidos e procedimentos de resposta a incidentes.",
        ],
      },
      {
        h: "2.8",
        t: "Retenção e exclusão",
        paras: [
          "Os dados serão armazenados pelo período necessário ao cumprimento de suas finalidades e obrigações legais ou regulatórias. Quando aplicável, os dados poderão ser eliminados ou anonimizados.",
          "O encerramento da conta não implica necessariamente exclusão imediata de todos os registros, especialmente quando houver fundamentos legais para sua conservação.",
        ],
      },
      {
        h: "2.9",
        t: "Direitos dos titulares",
        paras: [
          "Nos termos da LGPD, os titulares poderão exercer os direitos legalmente aplicáveis, incluindo:",
        ],
        list: [
          "Confirmação da existência de tratamento;",
          "Acesso aos dados;",
          "Correção de informações incompletas, inexatas ou desatualizadas;",
          "Informações sobre compartilhamento;",
          "Portabilidade, quando aplicável;",
          "Eliminação de dados nas hipóteses previstas em lei;",
          "Revogação de consentimento;",
          "Informações sobre a possibilidade de não consentir e suas consequências;",
          "Oposição ao tratamento nas hipóteses legais;",
          "Revisão de decisões automatizadas, conforme os requisitos legais.",
        ],
      },
      {
        h: "2.10",
        t: "Pré-cadastro e avisos de lançamento",
        paras: [
          "Os dados fornecidos no formulário de pré-cadastro serão utilizados para registrar o interesse nas funcionalidades do OFF360 e enviar comunicações relativas aos lançamentos escolhidos.",
          "O envio de campanhas comerciais adicionais respeitará a autorização do usuário e as bases legais aplicáveis. O titular poderá solicitar o cancelamento das comunicações.",
        ],
      },
      {
        h: "2.11",
        t: "Cookies e tecnologias semelhantes",
        paras: [
          "Caso o site utilize cookies, tecnologias de análise de navegação ou rastreadores, suas finalidades serão informadas de maneira clara. Cookies estritamente necessários poderão ser utilizados conforme as condições legais aplicáveis. Cookies não essenciais receberão o tratamento de consentimento ou outra base legal apropriada, segundo a legislação e as orientações regulatórias aplicáveis.",
        ],
      },
      {
        h: "2.12",
        t: "Crianças e adolescentes",
        paras: [
          "O tratamento de dados pessoais de crianças e adolescentes observará seu melhor interesse e as regras legais específicas.",
        ],
      },
      {
        h: "2.13",
        t: "Contato para privacidade",
        paras: [
          "As solicitações poderão ser encaminhadas ao canal oficial: contato@off360.com.br.",
        ],
      },
      {
        h: "2.14",
        t: "Atualizações",
        paras: [
          "A Política de Privacidade poderá ser atualizada para refletir modificações legais, técnicas ou operacionais. A versão vigente e a data da última atualização serão exibidas nesta página.",
        ],
      },
    ],
  },

  "termos-passageiros": {
    slug: "termos-passageiros",
    eyebrow: "Área legal · Termos de Uso",
    title: "Termos de Uso — Passageiros",
    intro:
      "Condições de utilização do 360Taxi pelos passageiros, incluindo cadastro, solicitação de corridas, pagamentos, segurança e responsabilidades.",
    version: "1.0",
    sections: [
      {
        h: "3.1",
        t: "Objeto",
        paras: [
          "Os presentes Termos regulam a utilização do 360Taxi pelos passageiros. O 360Taxi é uma plataforma tecnológica de mobilidade destinada a conectar passageiros a motoristas parceiros para realização de corridas, conforme disponibilidade e condições do serviço.",
        ],
      },
      {
        h: "3.2",
        t: "Cadastro",
        paras: [
          "O usuário deverá fornecer informações verdadeiras e atualizadas, sendo responsável pela preservação de suas credenciais e pela comunicação de eventuais acessos não autorizados. O cadastro estará sujeito aos requisitos legais e às condições de uso da plataforma.",
        ],
      },
      {
        h: "3.3",
        t: "Solicitação de corridas",
        paras: [
          "O passageiro poderá informar origem e destino, consultar as categorias disponíveis e solicitar uma viagem. As informações de trajeto, tempo estimado, valor e disponibilidade serão apresentadas conforme as funcionalidades da plataforma.",
          "A disponibilidade de motoristas não é garantida em todos os locais ou momentos.",
        ],
      },
      {
        h: "3.4",
        t: "Categorias",
        groups: [
          { t: "Básico", d: "opção de mobilidade para deslocamentos cotidianos." },
          { t: "Select", d: "categoria diferenciada de conforto." },
          { t: "Premium", d: "categoria de padrão elevado de atendimento e experiência." },
        ],
        paras2: [
          "A disponibilidade dependerá da região e das condições operacionais.",
        ],
      },
      {
        h: "3.5",
        t: "Pagamentos",
        paras: [
          "As formas de pagamento disponíveis poderão incluir Pix, cartão e dinheiro. Os valores, as condições de cobrança, os possíveis ajustes e eventuais taxas serão informados de maneira clara antes da confirmação, conforme a operação efetivamente implementada.",
          "As regras de cancelamento, reembolso e contestação corresponderão à política contratual vigente.",
        ],
      },
      {
        h: "3.6",
        t: "Segurança e conduta",
        paras: ["O passageiro deverá:"],
        list: [
          "Respeitar o motorista;",
          "Preservar as condições do veículo;",
          "Não praticar atos ilegais;",
          "Conferir as informações da viagem;",
          "Utilizar adequadamente os recursos de segurança;",
          "Comunicar incidentes pelos canais oficiais.",
        ],
      },
      {
        h: "3.7",
        t: "Responsabilidades",
        paras: [
          "As responsabilidades da plataforma, motoristas e passageiros observarão a legislação aplicável. Nenhuma disposição excluirá direitos legalmente assegurados aos consumidores ou afastará responsabilidades que não possam ser limitadas por contrato.",
        ],
      },
      {
        h: "3.8",
        t: "Suspensão ou encerramento",
        paras: [
          "O acesso poderá ser suspenso nas hipóteses contratualmente previstas, observados os direitos aplicáveis. O usuário poderá solicitar a exclusão da conta conforme os procedimentos disponibilizados.",
        ],
      },
    ],
  },

  "termos-motoristas": {
    slug: "termos-motoristas",
    eyebrow: "Área legal · Termos de Uso",
    title: "Termos de Uso — Motoristas",
    intro:
      "Condições de cadastro e utilização do 360Taxi pelos motoristas parceiros, incluindo requisitos, categorias, modelo comercial e recebimentos.",
    version: "1.0",
    sections: [
      {
        h: "4.1",
        t: "Objeto",
        paras: [
          "Estes Termos estabelecem as condições de cadastro e utilização do 360Taxi pelos motoristas parceiros.",
        ],
      },
      {
        h: "4.2",
        t: "Requisitos de cadastro",
        paras: [
          "O motorista deverá fornecer dados corretos e documentos válidos. Poderão ser exigidos:",
        ],
        list: [
          "Informações pessoais;",
          "CNH válida com EAR;",
          "Documentação do veículo;",
          "Comprovantes e verificações de segurança;",
          "Seguro obrigatório definido para a operação;",
          "Outros documentos exigidos pela regulamentação e pela plataforma.",
        ],
        paras2: [
          "A regra comercial atual prevê veículos com idade máxima de 10 anos, além dos demais requisitos aplicáveis.",
        ],
      },
      {
        h: "4.3",
        t: "Análise e aprovação",
        paras: [
          "O cadastro estará sujeito à análise documental e aos procedimentos de validação. O envio da documentação não garante aprovação automática.",
          "O motorista somente poderá ficar online e receber corridas após cumprir os requisitos obrigatórios de aprovação e regularização de acesso.",
        ],
      },
      {
        h: "4.4",
        t: "Categorias",
        paras: [
          "O enquadramento será realizado pela plataforma, sujeito à avaliação das informações apresentadas e passível de revisão conforme as regras aplicáveis:",
        ],
        list: [
          "Básico: recebe solicitações Básico;",
          "Select: pode receber solicitações Select e Básico;",
          "Premium: pode receber solicitações Premium, Select e Básico.",
        ],
      },
      {
        h: "4.5",
        t: "Condições comerciais",
        paras: [
          "O modelo comercial previsto para o 360Taxi utiliza mensalidade, sem comissão percentual da plataforma sobre cada corrida. A mensalidade aplicável poderá variar conforme o faturamento e as condições comerciais vigentes.",
          "O contrato definitivo definirá claramente:",
        ],
        list: [
          "Valores;",
          "Faixas de faturamento;",
          "Critérios de apuração;",
          "Período de referência;",
          "Vencimento;",
          "Período gratuito, quando existente;",
          "Condições de renovação;",
          "Cobrança;",
          "Inadimplência;",
          "Suspensão;",
          "Cancelamento;",
          "Eventuais tarifas de terceiros.",
        ],
      },
      {
        h: "4.6",
        t: "Pagamentos e recebimentos",
        paras: [
          "Os pagamentos eletrônicos das corridas poderão ser processados por prestador financeiro integrado, observadas as condições contratuais e a disponibilidade do serviço. As informações de recebimentos e movimentações serão apresentadas conforme as funcionalidades habilitadas no aplicativo.",
          "Nas corridas pagas em dinheiro, aplica-se o fluxo real de confirmação e registro previsto na plataforma. As condições de disponibilidade de saldo, transferência, saques, bloqueios, contestação e eventuais tarifas serão apresentadas de maneira transparente.",
        ],
      },
      {
        h: "4.7",
        t: "Obrigações do motorista",
        paras: ["O motorista deverá:"],
        list: [
          "Cumprir a legislação de trânsito;",
          "Manter a habilitação e a documentação válidas;",
          "Cumprir as regras de segurança;",
          "Manter o veículo em condições adequadas;",
          "Oferecer atendimento respeitoso;",
          "Não utilizar indevidamente informações dos passageiros;",
          "Cumprir obrigações regulatórias aplicáveis;",
          "Comunicar alterações relevantes em seus dados ou veículo.",
        ],
      },
      {
        h: "4.8",
        t: "Seguro",
        paras: [
          "O motorista deverá atender aos requisitos de seguro exigidos para sua aprovação e permanência na plataforma. As condições específicas de cobertura, contratação, vigência e comprovação corresponderão à apólice e às regras efetivamente vigentes.",
        ],
      },
      {
        h: "4.9",
        t: "Suspensão e bloqueio",
        paras: [
          "O acesso poderá ser restringido nas hipóteses contratualmente previstas, incluindo irregularidades documentais, inadimplência, riscos de segurança ou descumprimento das condições da plataforma. Os procedimentos de contestação ou revisão serão definidos de maneira clara.",
        ],
      },
      {
        h: "4.10",
        t: "Encerramento da conta",
        paras: [
          "O motorista poderá solicitar o encerramento da conta e o tratamento dos dados pessoais associados. Obrigações financeiras e registros sujeitos à retenção legal serão tratados de acordo com a legislação aplicável.",
        ],
      },
    ],
  },

  "termos-empresarios": {
    slug: "termos-empresarios",
    eyebrow: "Área legal · Termos de Uso",
    title: "Termos de Uso — Empresários",
    intro:
      "Condições aplicáveis ao OFF360 para Empresários, serviço em desenvolvimento e ainda não disponível para contratação.",
    version: "1.0",
    sections: [
      {
        h: "5.1",
        t: "Aviso obrigatório — serviço em desenvolvimento",
        paras: [
          "O OFF360 está desenvolvendo soluções comerciais para empresários e estabelecimentos, incluindo ferramentas de divulgação, campanhas promocionais, descontos e conexão com consumidores.",
          "Os recursos ainda não estão disponíveis para contratação. As condições comerciais definitivas serão publicadas antes da ativação do serviço. Até o lançamento, o usuário poderá apenas registrar voluntariamente interesse em receber informações.",
        ],
      },
      {
        h: "5.2",
        t: "O que não está disponível neste momento",
        list: [
          "Contratação de planos;",
          "Cobrança;",
          "Checkout;",
          "Criação operacional de campanhas;",
          "Ativação de estabelecimentos;",
          "Aceite de termos contratuais definitivos ainda não aprovados.",
        ],
      },
      {
        h: "5.3",
        t: "Antes do lançamento comercial",
        paras: [
          "Antes do lançamento comercial, a empresa disponibilizará os termos completos de contratação, incluindo planos, pagamentos, cancelamentos, responsabilidade pelas ofertas e utilização de dados. O 360Taxi é o serviço principal do lançamento atual.",
        ],
      },
    ],
  },

  "excluir-conta": {
    slug: "excluir-conta",
    eyebrow: "Área legal · Privacidade e dados",
    title: "Exclusão de Conta e Dados — OFF360 / 360Taxi",
    intro:
      "Você pode solicitar a exclusão da sua conta e dos dados pessoais associados aos serviços do OFF360, respeitadas as hipóteses de conservação legalmente permitidas. Para iniciar sua solicitação, preencha o formulário disponível nesta página.",
    version: "1.0",
    sections: [
      {
        h: "6.1",
        t: "Formulário de solicitação",
        paras: [
          "O formulário desta página recebe solicitações sem exigir login. São solicitados: nome completo, e-mail vinculado à conta, perfil (Passageiro, Motorista ou Empresário), telefone cadastrado (opcional), tipo de solicitação e observações (opcionais).",
        ],
        list: [
          "Excluir minha conta;",
          "Solicitar exclusão de dados pessoais;",
          "Solicitar acesso ou correção de dados;",
          "Outro assunto relacionado à privacidade.",
        ],
      },
      {
        h: "6.2",
        t: "Funcionamento da solicitação",
        paras: [
          "Ao enviar o formulário, a solicitação é validada e registrada em sistema protegido, com geração de número de protocolo e encaminhamento à área administrativa responsável.",
        ],
        list: [
          "A titularidade é verificada de forma segura antes de qualquer exclusão sensível;",
          "A solicitação pode ser acompanhada administrativamente;",
          "Os dados cabíveis são encaminhados para exclusão ou anonimização;",
          "A conclusão ou a justificativa de retenção legal é registrada;",
          "A confirmação da solicitação é disponibilizada ao titular.",
        ],
      },
      {
        h: "6.3",
        t: "Verificação de titularidade",
        paras: [
          "Nenhuma exclusão irreversível é executada apenas com base em um e-mail informado por terceiro, sem verificação adequada de identidade. A equipe responsável poderá solicitar informações adicionais para confirmar a titularidade.",
        ],
      },
      {
        h: "6.4",
        t: "Exclusão dentro do aplicativo",
        paras: [
          "O 360Taxi também disponibilizará mecanismo acessível para que usuários autenticados possam solicitar a exclusão da conta. A existência desta página não substitui essa necessidade. A exclusão considera os dados associados ao usuário, e não apenas a desativação do login.",
        ],
      },
      {
        h: "6.5",
        t: "Retenção legal",
        paras: [
          "Dados necessários ao cumprimento de obrigações legais ou regulatórias, exercício regular de direitos e outras hipóteses legalmente admitidas poderão ser conservados pelo período correspondente. O titular receberá informações adequadas sobre a solicitação e eventuais limitações legais à exclusão.",
        ],
      },
    ],
  },
};
